module.exports = __webpack_public_path__ + "img/Page1BB.b7b00ad8.jpg";